import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from 'src/app/models';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiKaspiSettingsService {

  constructor(
    private api: ApiService
  ) { }


  /**
   * 
   * @returns Observable<Res>
   */
  uploadInfo(): Observable<Res> {

    return this.api.get('getCredentialData', '', 'private', 'integrationKaspi');
  }

  /**
   * 
   * @returns Observable<Res>
   */
  downloadInfo(): Observable<Res> {

    return this.api.get('getPriceListCredentialData', '', 'private', 'integrationKaspi');
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  uploadSave(params: any): Observable<Res> {

    return this.api.post('saveCredentialData', params, 'private', 'integrationKaspi');
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  dowloadSave(params: any): Observable<Res> {

    return this.api.post('savePriceListCredentialData', params, 'private', 'integrationKaspi');
  }
}
